import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import {
  BackendFeatureService,
  CustomPageConfigService,
  PasswordPolicyService,
  TableRecord,
  UserDetailsUserComponent,
  UsersService
} from 'gung-standard';
import { Observable } from 'rxjs';
import { CarLinerFileUploadedService } from '../../../services/car-liner-file-uploaded.service';
import { GungUser as User } from 'gung-standard';

@Component({
    selector: 'car-liner-user-details-user',
    templateUrl: './car-liner-user-details-user.component.html',
    styleUrls: ['./car-liner-user-details-user.component.scss'],
    standalone: false
})
export class CarLinerUserDetailsUserComponent extends UserDetailsUserComponent implements OnInit {
  fileName: string;

  constructor(
    protected usersService: UsersService,
    protected http: HttpClient,
    protected customPagesService: CustomPageConfigService,
    private carLinerFileUploadedService: CarLinerFileUploadedService,
    protected backendFeatureService: BackendFeatureService,
    protected passwordPolicyService: PasswordPolicyService
  ) {
    super(usersService, http, backendFeatureService, passwordPolicyService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.currentUser.extra = this.currentUser.extra || {};
    const customLogo = this.currentUser.extra?.customLogo;
    if (customLogo) {
      this.fileName = customLogo.split('/').pop();
    }
  }

  uploadFile(file): Observable<any> {
    const imageObject = {
      index: 0,
      description: 'Vas File - ' + new Date().getTime(),
      category: file.type
    };
    const formData = new FormData();
    formData.append('file', file);
    formData.append('productImage', JSON.stringify(imageObject));
    return this.customPagesService.uploadImageS3(formData);
  }

  onFileChange(event) {
    const files = (event.target as HTMLInputElement).files;
    if (files && files.length > 0) {
      this.fileName = files[0].name;
      this.carLinerFileUploadedService.file = event.target.files[0];
    }
  }

  removeImg(index: any): void {
    delete this.currentUser.extra?.customLogo;
    this.fileName = '';
    this.update();
  }

  sortCountriesAlphabetically(a: TableRecord, b: TableRecord): 0 | 1 | -1 {
    return a.value.localeCompare(b.value) as 0 | 1 | -1;
  }
}
